/** @jsx jsx */
import { css } from "@emotion/react";
import shapes from '../images/LP-versar/form-bg.svg'
export const formSectionStyles = css`
  display: flex;
  flex-direction: column;
  background-color: #776AAE;
  padding-block: 57px;
  background-image: url(${shapes});
  background-repeat: no-repeat;
  background-size: cover;
  overflow: clip;
  scroll-margin-top: 100px;

  @media (max-width: 768px) {
      background-color: #CFC5E5;
    }

  .form-container {
    display: flex;
    justify-content: center;
    margin-bottom: 35px;
  }

  .form-div {
    background: #CFC5E5;
    border:1px solid #2f2c4f;
    padding: 70px;
    align-items: center;
    flex-direction: column;
    display: flex;
    justify-content: flex-start;
    /* height: 556px; */
    border-radius: 47px;
    @media (max-width: 768px) {
      margin-bottom: 32px;
      padding: 0;
      background-color: transparent;
      border: none;
    }

    h1 {
    color:  #4b4b4b;
    text-align: center;
    font-family: "owners-narrow", sans-serif;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    width: 100%;
    max-width: 730px;
    span {
      color: #8A588D;
      font-style: italic;
    }
  }
  p{
    width: 100%;
    max-width: 440px;
    color:  #4b4b4b;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    line-height: 120%;
    text-align: center;
  }
  }

  form {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 540px;
    gap: 8px;
    border-radius: 16px;
    .text_input_containe {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
    }
    .text_input {
      background-color: rgba(255,255,255,0.5);
      border-radius: 8px;
      border: 1px solid #2f2c4f;
      padding: 14px 16px;
      width: 100%;
      outline: none;
      margin-bottom: 8px;
      &:focus{
        outline: none;
      }
      &::placeholder {
        color: #375F92;
        font-family: Montserrat;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.36px;
      }
    }
    select{
      background-color: rgba(255,255,255,0.5);
      border-radius: 8px;
      border: 1px solid #2f2c4f;
      padding: 14px 16px;
      width: 100%;
      outline: none;
      margin-bottom: 8px;
    }
    label{
      font-family: Montserrat;
      font-size: 16px;
    }
  }

`;

export const form = css`
align-items: center;

button {
  background-color: #776AAE;
  border: none;
  border-radius: 12px;
  color: #FFF;
  text-align: center;
  font-family: "owners-narrow", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  position: relative;
  text-transform: uppercase;
  padding: 15px 56px;
  overflow: hidden;
}

button span {
  font-weight: 700;
  z-index: 2;
  position: relative;
}
button:hover span {
  color:#776AAE;
}

button:before {
  aspect-ratio: 1;
  background: #fff;
  border-radius: 50%;
  content: "";
  left: 50%;
  position: absolute;
  top: 50%;
  opacity: 0;
  transform: translate(-50%, -50%);
  transition: 0.4s;
  width: 0;
}
button:hover:before {
  width: 110%;
  opacity: 1;
}

button:disabled {
  background-color: #4b4b4b !important;
  cursor: not-allowed;
}

button:hover {
  background-color: #776AAE;
}
button:active {
  background-color: #375F92;
}

button img{
  filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(23deg) brightness(100%) contrast(106%);
  position: absolute;
  top: 50%;
  right: -20px;
  transform: translateY(-50%);
  transition: .2s ease-in-out;
}
button:hover img{
  right: 30px;
  filter: brightness(0) saturate(100%) invert(41%) sepia(58%) saturate(367%) hue-rotate(211deg) brightness(95%) contrast(94%);
}

.role-container {
  display: flex;
  flex-direction: column;
  span {
    color: #4B4B4B;
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -0.36px;
  }

  .roles-checkbox {
    background-color: #FFEFE8;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    /* margin-bottom: 32px; */
    max-width: 540px;
    padding: 18px 30px 40px 30px;
    width: 100%;

    span {
      margin-bottom: 16px;
    }

    .double_role {
      display: flex;
      justify-content: space-around;
      width: 100%;
    }

    .single-role {
      color: #4b4b4b;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;


      .form-control {
        color: #4b4b4b;
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        display: grid;
        grid-template-columns: 1em auto;
        gap: 0.5em;
        border: none;
        background-color: transparent;
        align-items: center;
        padding: 0;
      }

      input[type="checkbox"] {
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        margin: 0;
          font: inherit;
        color: currentColor;
        width: 16px;
        height: 16px;
        border: 2px solid #375F92;
        border-radius: 4px;
        transform: translateY(-0.075em);
          display: grid;
        place-content: center;
      }

      input[type="checkbox"]::before {
        content: "";
        width: 6px;
        height: 6px;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em #4b4b4b;
        border-radius: 2px;
      }

      input[type="checkbox"]:checked::before {
        transform: scale(1);
      }

      .form-control + .form-control {
        margin-top: 1em;
      }

      input[type="radio"] {
        -webkit-appearance: none;
        appearance: none;
        background-color: #ffffff;
        margin: 0;
          font: inherit;
        color: currentColor;
        width: 16px;
        height: 16px;
        border: 2px solid #4b4b4b;
        border-radius: 10px;
        transform: translateY(-0.075em);
          display: grid;
        place-content: center;
        cursor: pointer;
      }

      input[type="radio"]::before {
        content: "";
        width: 6px;
        height: 6px;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em #776AAE;
        border-radius: 10px;
      }

      input[type="radio"]:checked::before {
        transform: scale(1);
      }

    }

    .other {
      background-color: transparent;
      outline: none;
      width: 100%;
      border: none;
      border-bottom: 2px solid #375F92;
      &::placeholder {
        color:  #375F92;
        font-family: Montserrat;
        font-size: 16px;
        font-style: italic;
        font-weight: 500;
        line-height: 150%;
      }
    }
  }
  
}

.disabled{
    bottom: 0;
    left: 50%;
    width: 280px;
    height: 60px;
    background-color: transparent !important;
    cursor: not-allowed;
    position: absolute;
    transform: translateX(-50%);
    z-index: 3;
  }

`;
